document.addEventListener('DOMContentLoaded', () => {

	//.wp-block-flashblocks-block-marquee
	const containers = document.querySelectorAll('.marquee .marquee__group');
	containers.forEach(container => {
		for (let i = 0; i < 2; i++) {
			const clone = container.cloneNode(true);
			container.parentNode.appendChild(clone);
		}
	});
});
